import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import { OverviewWidget } from "./OverviewWidget";


export type RiskRatingsWidgetProps = {
	model: object; // Replace withg risk rating values
}
/**
 * Widget that displays risk ratings.
 * 
 * Used by two pages
 * - Customer Application Detail 
 * - Customer Detail (Replace CustomerOverviewRiskScorew with this)
 */
export function RiskRatingsWidget(props: RiskRatingsWidgetProps) {
	const { 
	} = props;
	return (
		<OverviewWidget
			title="Risk Ratings"
			className="risk-ratings"
		>
		</OverviewWidget>
	)
}